(function (angular) {
	'use strict';

	var planCtaObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			ctaBaseUrl: '@?',
			ctaCallback: '&?',
			ctaDisabled: '<?',
			customCtaText: '@?',
			existingInvestor: '<?',
			funnel: '@?',
			investmentEntityId: '@?',
			investmentEntityType: '@?',
			isAuthenticated: '<',
			isClickable: '<?',
			isHovered: '<?',
			mouseDown: '<?',
			riaPlanName: '@?',
			selectedPlan: '@?'
		},
		controller: [
			'$scope',
			'APP_BASE_PATH',
			'PlanCardFactory',
			PlanCtaFunction
		],
		controllerAs: 'planCta'
	};

	angular
		.module('planModule')
		.component('planCta', planCtaObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/ria/shared/plans/plan-cta.html';
	}

	function PlanCtaFunction(
		$scope,
		APP_BASE_PATH,
		PlanCardFactory
	) {
		
		var planCta = this;
		
		$scope.$on('planCta:formSubmitted', function(evt, data) {
			if (data.submitted) {
				if (data.planName === planCta.selectedPlan) {
					planCta.formSubmitted = true;
				}
			} else {
				planCta.formSubmitted = false;
			}
		});

		planCta.$onInit = function() {
			var ctaState = PlanCardFactory.getPlanCtaState(planCta.riaPlanName, planCta.funnel, planCta.isAuthenticated, planCta.existingInvestor);
			planCta.ctaData = PlanCardFactory.getPlanCtaDataFromState(ctaState, planCta.selectedPlan, planCta.investmentEntityId, planCta.investmentEntityType);

			if(planCta.customCtaText) {
				planCta.ctaData.text = planCta.customCtaText;
			}
		};

	}
})(window.angular);